module.exports = __webpack_public_path__ + "img/placeholder.eb3fe035.jpg";